import { render } from "./4.CPM.vue?vue&type=template&id=fba4a4f0&scoped=true"
import script from "./4.CPM.vue?vue&type=script&lang=js"
export * from "./4.CPM.vue?vue&type=script&lang=js"

import "./4.CPM.vue?vue&type=style&index=0&id=fba4a4f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fba4a4f0"]])

export default __exports__